// src/components/layouts/AuthLayout.js

import React from 'react';
import MetaTags from '../MetaTags';
import HeaderComponent from '../HeaderComponent';
import FooterComponent from '../FooterComponent';
import { Link } from 'react-router-dom';
import logoPath from '../../assets/img/logo_back_1.png';

// 1. IMPORTANT: Make sure this file is named AuthLayout.css (NOT .module.css)
//    and use a standard global import.
import './AuthLayout.css'; 

import { Users, ShieldCheck, Star, TrendingUp } from 'lucide-react';

const AuthLayout = ({ pageTitle, metaDescription, sidebarTitle, subtitle, leftTitle, leftSubtitle, children, className = '' }) => {
  return (
    <div className={`auth-page-wrapper ${className}`}>
      <MetaTags title={pageTitle} description={metaDescription} />
   
      <main className="auth-main-container">
        
        {/* Left Side: Features & Branding */}
        <div className="auth-left-panel d-none d-lg-flex">
          <div className="auth-left-content">
            <h1 className="auth-main-title">
              {leftTitle ? leftTitle : (
                <>Your Journey <br /><span className="text-red">Starts Here</span></>
              )}
            </h1>
            <p className="auth-main-subtitle">
              {leftSubtitle ? leftSubtitle : "India's most trusted platform for auditions, castings, workshops and talent discovery."}
            </p>

            <div className="auth-features-list">
              <div className="auth-feature-item">
                <div className="auth-feature-icon icon-red"><Users size={20} /></div>
                <div>
                  <h4 className="auth-feature-title">Verified Opportunities</h4>
                  <p className="auth-feature-desc">100% genuine & trusted</p>
                </div>
              </div>
              <div className="auth-feature-item">
                <div className="auth-feature-icon icon-yellow"><ShieldCheck size={20} /></div>
                <div>
                  <h4 className="auth-feature-title">Secure & Safe</h4>
                  <p className="auth-feature-desc">Your data is always protected</p>
                </div>
              </div>
              <div className="auth-feature-item">
                <div className="auth-feature-icon icon-purple"><Star size={20} /></div>
                <div>
                  <h4 className="auth-feature-title">All in One Platform</h4>
                  <p className="auth-feature-desc">Auditions, Castings, Workshops & more</p>
                </div>
              </div>
              <div className="auth-feature-item">
                <div className="auth-feature-icon icon-green"><TrendingUp size={20} /></div>
                <div>
                  <h4 className="auth-feature-title">Track & Grow</h4>
                  <p className="auth-feature-desc">Track your progress and get discovered</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side: Form Card */}
        <div className="auth-right-panel">
          <div className="login-container-custom">
            {/* <div className="text-center mb-4">
              <Link to="/">
                <img src={logoPath} alt="Logo" className="auth-logo" />
              </Link>
            </div> */}
            
            <div className="auth-header-text text-center">
              <h2 className="login-title-custom">{sidebarTitle}</h2>
              <p className="subtitle-custom">{subtitle}</p>
            </div>
            
            <div className="auth-content">
              {children}
            </div>
          </div>
        </div>

      </main>
    </div>
  );
};

export default AuthLayout;